import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

/**
 * This action can be dispatched to update the nextSearchQueryId value in the
 * store, likely at an unconvential conversation end (like selecting a direct
 * nav suggestion in QF).
 */
export const updateNextSearchQueryId = action(
    'updateNextSearchQueryId',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);

export default updateNextSearchQueryId;
